import * as O from "fp-ts/Option";
import * as AD2 from "lib/at-data/AsyncData2";
import { RootState } from "views/authenticated/root/controller/state";

export const initialState: RootState = {
  assets: AD2.pending(O.none),
  assetTags: [],
};
